import React, { useEffect } from "react";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";
import FlowerDivider from "../components/FlowerDivider";

export default function UeberMich() {
  const { t } = useLang();
  useEffect(() => window.scrollTo({ top: 0 }), []);
  return (
    <main className="pt-28 md:pt-32" data-testid="about-page">
      <section className="py-14 md:py-20">
        <div className="container-x text-center">
          <h1 className="display text-4xl sm:text-5xl md:text-7xl">{t.about.label}</h1>
          <FlowerDivider />
          <p className="font-serif italic text-2xl text-[var(--gold)]">{t.about.name}</p>
          <p className="mt-1 text-sm tracking-[0.25em] uppercase text-[var(--ink-soft)]">{t.about.role}</p>
        </div>

        <div className="container-x grid md:grid-cols-12 gap-8 md:gap-12 mt-10 md:mt-14 items-center">
          <div className="md:col-span-5">
            <div className="img-mask aspect-[4/5] rounded-3xl"><img src={IMAGES.aboutPortrait} alt={t.about.name} /></div>
          </div>
          <div className="md:col-span-7 space-y-4 md:space-y-5 text-[16px] md:text-[17px] leading-relaxed text-[var(--ink-soft)]">
            <p>{t.about.p1}</p>
            <p>{t.about.p2}</p>
            <p className="font-serif italic text-[var(--ink)] text-lg md:text-xl border-l-4 border-[var(--gold)] pl-4 md:pl-5 py-1">{t.about.p3}</p>
          </div>
        </div>

        <div className="container-x mt-16 md:mt-20">
          <div className="text-center">
            <h2 className="display text-3xl sm:text-4xl md:text-5xl">{t.gallery.label}</h2>
            <FlowerDivider />
            <p className="text-[var(--ink-soft)]">{t.gallery.sub}</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mt-8 md:mt-10">
            {IMAGES.gallery.map((src, i) => (
              <div key={i} className="img-mask aspect-[4/5] rounded-2xl"><img src={src} alt={`Impression ${i+1}`} /></div>
            ))}
          </div>
        </div>

        <div className="container-x mt-16 md:mt-20 text-center max-w-3xl mx-auto">
          <span className="block text-6xl md:text-7xl font-serif text-[var(--gold)] leading-none">“</span>
          <p className="font-serif italic text-xl md:text-3xl leading-snug mt-2">{t.quote}</p>
          <p className="mt-4 md:mt-5 text-xs md:text-sm tracking-[0.3em] uppercase text-[var(--ink-soft)]">— {t.quoteBy}</p>
        </div>
      </section>
    </main>
  );
}
